import React from "react";
import "./BuildingOverviewSkeleton.css";

const Shimmer = ({ className = "" }) => <span className={`bov-skeleton-shimmer ${className}`} aria-hidden />;

const FieldBlock = ({ size = "md" }) => (
    <div className={`bov-skeleton-field bov-skeleton-field--${size}`}>
        <Shimmer className="bov-skeleton-label" />
        <Shimmer className="bov-skeleton-value" />
    </div>
);

const BandSection = ({ title, children, className = "" }) => (
    <div className={`bov-skeleton-band ${className}`}>
        <div className="bov-skeleton-band__head">
            <Shimmer className="bov-skeleton-band__title" />
        </div>
        <div className="bov-skeleton-band__body">{children}</div>
    </div>
);

const FieldGrid = ({ count = 8, colClass = "col-md-3" }) => (
    <div className="row bov-skeleton-grid">
        {Array.from({ length: count }).map((_, i) => (
            <div key={i} className={`${colClass} bov-skeleton-grid__cell`}>
                <FieldBlock size={colClass.includes("4") ? "sm" : "md"} />
            </div>
        ))}
    </div>
);

const BuildingOverviewSkeleton = ({ variant = "view" }) => {
    if (variant === "form") {
        return (
            <div className="bov-skeleton bov-skeleton--form" aria-busy="true" aria-label="Loading building details">
                <BandSection>
                    <FieldGrid count={12} colClass="col-md-3" />
                </BandSection>
                <BandSection>
                    <FieldGrid count={10} colClass="col-md-4" />
                </BandSection>
                <BandSection>
                    <div className="row bov-skeleton-grid">
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className="col-md-4 bov-skeleton-grid__cell">
                                <FieldBlock size="sm" />
                            </div>
                        ))}
                    </div>
                </BandSection>
                <BandSection>
                    <FieldGrid count={6} colClass="col-md-4" />
                </BandSection>
            </div>
        );
    }

    return (
        <div className="bov-skeleton bov-skeleton--view" aria-busy="true" aria-label="Loading building details">
            <div className="basic-otr row align-items-stretch cnt-sec basic-view bov-skeleton-row">
                <div className="col-md-8 m-details-content-outer">
                    <BandSection className="bov-skeleton-band--flush">
                        <FieldGrid count={8} colClass="col-md-3" />
                        <div className="row bov-skeleton-grid bov-skeleton-grid--tight">
                            {Array.from({ length: 3 }).map((_, i) => (
                                <div key={i} className="col-md-4 bov-skeleton-grid__cell">
                                    <FieldBlock size="sm" />
                                </div>
                            ))}
                        </div>
                    </BandSection>
                </div>
                <div className="col-md-4 m-details-content-outer">
                    <Shimmer className="bov-skeleton-image" />
                </div>
            </div>

            <div className="basic-otr row align-items-stretch cnt-sec basic-view bov-skeleton-row">
                <div className="col-md-8 m-details-content-outer">
                    <BandSection className="bov-skeleton-band--flush">
                        <FieldGrid count={12} colClass="col-md-4" />
                    </BandSection>
                </div>
                <div className="col-md-4 m-details-content-outer">
                    <Shimmer className="bov-skeleton-gauge" />
                </div>
            </div>

            <BandSection className="bov-skeleton-band--assessment">
                <div className="row bov-skeleton-grid">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="col-md-4 bov-skeleton-grid__cell">
                            <FieldBlock size="sm" />
                        </div>
                    ))}
                </div>
            </BandSection>

            <BandSection>
                <FieldGrid count={8} colClass="col-md-3" />
            </BandSection>
        </div>
    );
};

export default BuildingOverviewSkeleton;
